module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Box#1-80b697fec8351771be247ced469fc55b.svg";